export default {
  en: {
    'pages.tax-codes-details.invoice': 'Invoice Number',
    'pages.tax-codes-details.mapping.we-call-it': 'Transaction types - What we call it',
    'pages.tax-codes-details.mapping.you-call-it': 'Transaction types - What you call it',
    'pages.tax-codes-details.tax-code': 'Tax Code',
    'pages.tax-code-details.tax-code-input': 'Insert name',
    'pages.tax-code-details.tax-code-input.placeholder':
      'Insert Name, separate your codes with a semi colon. E.G. LocalA1; LocalA2',
    'pages.tax-code-details.options.description':
      'You need to make sure your columns match the VAT Global columns to ensure compliance. Name your tax codes accordingly or use our names.',
    'pages.tax-code-details.options.text': 'Insert your tax code names',
    'pages.tax-code-details.options.heading': 'Tax code Options',
    'pages.tax-code-details.options.save': 'Save',
    'pages.tax-code-details.options.add': 'Add',
    'pages.tax-code-details.options.remove': 'Remove',
    'pages.tax-code-details.options.copy': 'Copy to other registrations',
    'pages.tax-code-details.options.default': 'Use default names',
    'pages.tax-code-details.options.restart': 'Restart Wizard',
    'pages.tax-code-details.options.without-saved-message':
      'Please note you have not saved your changes to the tax codes, are you sure you want to leave?',
  },
};
